import React, { useEffect, useMemo, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Header from '../Pages/Header';
import Sidebar from '../Pages/Sidebar';
import { PAY_URL } from '../../../BaseURL';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Pagination, Search } from '../Table';
import CopyRight from '../Pages/CopyRight';
import Loader from '../Pages/Loader';
import ProcessLoader from '../Components/ProcessLoader';
import DropDonwlLimit from '../Components/DropDonwlLimit';

const PTReport = () => {
    const navigate = useNavigate();
    const [entity, setEntity] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [limit, setlimit] = useState(10);
    const [loader, setLoader] = useState(false);
    const [month, setMonth] = useState('');
    const [disable, setDisable] = useState(true);

    useEffect(() => {
        if (localStorage.getItem('PAY_USER_TOKEN') === null) {
            navigate("/user/login");
        }
        if (month && disable) {
            getReport();
            setEntity([]);
            setDisable(false);
        }
    }, [navigate, month, disable]);

    const commentsData = useMemo(() => {
        let computedComments = entity || [];

        if (search) {
            computedComments = computedComments.filter(
                (report) =>
                    report?.employeeName?.toLowerCase()?.includes(search?.toLowerCase()) ||
                    report?.employee_id?.toLowerCase()?.includes(search?.toLowerCase()) ||
                    report?.card_no?.toLowerCase()?.includes(search?.toLowerCase())
            );
        }

        setTotalItems(computedComments.length);

        return computedComments.slice(
            (currentPage - 1) * limit,
            (currentPage - 1) * limit + limit
        );

    }, [currentPage, search, limit, entity]);

    const getReport = () => {
        const formData = new URLSearchParams();
        formData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'));
        formData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'));
        formData.append('month', month);

        const myurl = `${PAY_URL}/user/list-pt-report`;
        axios({
            method: "POST",
            url: myurl,
            data: formData,
            headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
        }).then(async (response) => {
            if (response?.data?.success === true) {
                const data = response?.data?.data[0]?.items
                setEntity(data);
            }
        }).catch((error) => {
            toast.error(error.response?.data?.message || "Something went wrong");
        })
    }

    const handleMonthChange = (event) => {
        const selectedMonth = event.target.value;
        setMonth(selectedMonth);
    };

    const downloadReport = () => {
        if (month) {
            setLoader(true);
            const myurl = `${PAY_URL}/user/pt-report-download`;
            const bodyFormData = new URLSearchParams();
            bodyFormData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'));
            bodyFormData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'));
            bodyFormData.append('month', month)
            axios({
                method: "post",
                url: myurl,
                data: bodyFormData,
                headers: { "Content-Type": "application/x-www-form-urlencoded", Authorization: "Barrer " + localStorage.getItem('PAY_USER_TOKEN') },
            }).then((response) => {
                if (response.data.success === true) {
                    const fileUrl = response.data.data.file;
                    toast.success(response?.data?.message);
                    window.open(fileUrl, '_blank');
                }
                setLoader(false);
            }).catch((error) => {
                console.log(error, '!!');
                toast.error(error?.response?.data.message);
                setLoader(false);
            });
        } else {
            toast.error('Please select the month');
        }
    }

    const handleRefresh = () => {
        setDisable(true);
    }

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    return (
        <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title user-title">PT Report Management</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/user/dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item active">PT Report Management</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row filter-row justify-content-end">
                        <div className='col-md-4 col-lg-4 col-sm-12'>
                            <div className="row">
                                <div className="col-md-12 mb-2">

                                    <select className="form-select form-control" value={month} onChange={handleMonthChange}
                                        aria-label="Default select example">
                                        <option value=''>Select Month</option>
                                        <option value='1'>January</option>
                                        <option value='2'>February</option>
                                        <option value='3'>March</option>
                                        <option value='4'>April</option>
                                        <option value='5'>May</option>
                                        <option value='6'>June</option>
                                        <option value='7'>July</option>
                                        <option value='8'>August</option>
                                        <option value='9'>September</option>
                                        <option value='10'>October</option>
                                        <option value='11'>November</option>
                                        <option value='12'>December</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-12 col-md-8">
                            <div className="row justify-content-end">
                                <div className="col-md-12 mb-2">
                                    <div className="justify-content-end d-flex align-center flex-wrap gap-2">
                                        <div className="seletePage d-flex gap-2 align-items-center ">
                                            <p className="mb-0">Rows per page:</p>
                                            <div className="d-flex align-items-center justify-content-center gap-2">
                                                <DropDonwlLimit limit={limit} onLimitChange={(val) => setlimit(val)} />
                                                <div className="refreshPage">
                                                    <button className="btn btn-refresh" type='butotn' onClick={handleRefresh}>
                                                        <i className="fa-solid fa-arrows-rotate"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="seletePage d-flex gap-2 align-items-center ">
                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                    <div className="refreshPage">
                                                        <button className="btn btn-refresh" type='button' onClick={downloadReport}>
                                                            {loader ? <ProcessLoader /> : <i className="fa-solid fa-download"></i>}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="tableSearch">
                                            <form action="">
                                                <Search
                                                    onSearch={(value) => {
                                                        setSearch(value);
                                                        setCurrentPage(1);
                                                    }} />
                                                <span className="search">
                                                    <i className="fa-solid fa-magnifying-glass"></i>
                                                </span>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card p-3 ">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table mb-0">
                                        <thead>
                                            <tr>
                                                <th>Sr.</th>
                                                <th>Employee Name</th>
                                                <th>Card No.</th>
                                                <th>PT Amount</th>
                                                <th>Total Salary</th>
                                                <th>Work Days</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {commentsData?.map((elem, i) =>
                                                <tr key={elem?._id}>
                                                    <td>{(currentPage - 1) * limit + i + 1}</td>
                                                    <td>{elem?.employeeName}</td>
                                                    <td>{elem?.card_no}</td>
                                                    <td>{elem?.ptAmount}</td>
                                                    <td>{elem?.total_salary}</td>
                                                    <td>{elem?.work_day}</td>
                                                </tr>
                                            )}

                                            <tr>
                                                <td colSpan={3} className='text-center fw-bold'>Total</td>
                                                <th>
                                                    {commentsData?.reduce((total, elem) => total + (elem?.ptAmount || 0), 0)}
                                                </th>
                                                <th>
                                                    {commentsData?.reduce((total, elem) => total + (elem?.total_salary || 0), 0)}
                                                </th>
                                                <th>
                                                    {commentsData?.reduce((total, elem) => total + (elem?.work_day || 0), 0)}
                                                </th>
                                            </tr>

                                            {commentsData?.length === 0 ? (
                                                <tr>
                                                    <td colSpan="999">
                                                        <div className="no-table-data">
                                                            No Data Found!
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : null}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row align-center mt-3 user-account">
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                        <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                                            aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                        <div className="dataTables_paginate paging_simple_numbers"
                                            id="DataTables_Table_0_paginate">
                                            <Pagination
                                                total={totalItems}
                                                itemsPerPage={limit}
                                                currentPage={currentPage}
                                                onPageChange={(page) => setCurrentPage(page)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <CopyRight />
                </div>
            </div>
        </div>
    )
}

export default PTReport